export default `
    <a class="pane-body-icon-container link pointer hover-image-container #= data.classes||"" #"
        # if (data.disabled) { # disabled # } #
         id="#= data.id #"
        # if (data.href) { # href="#= data.href #" # } #
        # if (data.toolTip) { # title="#= data.toolTip #" # } #>
        # if (data.iconClass) { #
        <span class="pane-body-icon #= data.iconClass #">
        </span># } #
        # if (data.bindLabel) { #
            <span data-label-for-id="#= data.id #" class="icon-label bind-label" data-bind="#= data.bindLabel #"></span>
            # if (data.bindValue) { #
                <span class="bind-value" data-bind="text: #: data.bindValue #"></span>
            # } #
            # if (data.counterValue) { #
                <span><span class="bind-value icon-label #= data.counterClass #" data-bind="countText: #= data.counterValue #"></span></span>
            # } #
        # } #
    </a>
`;
